import React, { Fragment } from 'react';
import type { CustomFloatingFilterProps } from 'ag-grid-react';
import * as Bixby from '$/core';
import './lastModifiedFilterComponent.scss';

export interface LastModifiedFilterProps extends CustomFloatingFilterProps {
  currentValue: Bixby.Enums.DataSiteDocumentFilter;
  onSortChange: (value: Bixby.Enums.DataSiteDocumentFilter) => void;
}

export default ({ currentValue, onSortChange }: LastModifiedFilterProps) => {
  const handleSortChange = (event: React.FormEvent<HTMLSelectElement>) => {
    const value = event.currentTarget.value as Bixby.Enums.DataSiteDocumentFilter;
    onSortChange(value);
  };

  return (
    <Fragment>
      <div className="filter_wrap">
        <select onChange={handleSortChange}>
          <option
            value={`${Bixby.Enums.DataSiteDocumentFilter.LastHour}`}
            selected={currentValue === Bixby.Enums.DataSiteDocumentFilter.LastHour}>
            Last Hour
          </option>
          <option
            value={`${Bixby.Enums.DataSiteDocumentFilter.LastDay}`}
            selected={currentValue === Bixby.Enums.DataSiteDocumentFilter.LastDay}>
            Last Day
          </option>
          <option
            value={`${Bixby.Enums.DataSiteDocumentFilter.LastWeek}`}
            selected={currentValue === Bixby.Enums.DataSiteDocumentFilter.LastWeek}>
            Last Week
          </option>
          <option
            value={`${Bixby.Enums.DataSiteDocumentFilter.LastMonth}`}
            selected={currentValue === Bixby.Enums.DataSiteDocumentFilter.LastMonth}>
            Last Month
          </option>
        </select>
      </div>
    </Fragment>
  );
};
